export default __webpack_public_path__ + "static/media/education.f097c08e.jpeg";